// extracted by mini-css-extract-plugin
export var closeButton = "_kr-1";
export var closeX = "_kr-3";
export var container = "_kr-0";
export var image = "_kr-2";